<template>
  <div class="tableWithPerPageSelection">
    <a ref="lienDownload"></a>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="manageActions"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="ecransSelectionnees"
            ></selecteur-action>
          </div>
        </div>
      </div>
      <div class="columns level-right">
      </div>
    </div>
    <v-client-table
        url=""
        v-model="ecranSelected"
        :columns="columns"
        :options="options"
        @filter="refreshFilteredData"
        ref="ecranInSelectionTable">
      <template slot="selected" slot-scope="{ row, update }">
        <div class="has-text-centered">
          <b-checkbox
            v-model="row.selected"
            @input="(e) => {
              update(e); refreshFilteredData()
            }">
          </b-checkbox>
        </div>
      </template>
      <template slot="reference" slot-scope="props">
        <router-link-blank
          :to="{ name: 'c.bodac.catalogue-ecranNumerique',
            params: { id: props.row.id }}"
          :message="props.row.reference"/>
      </template>
      <template slot="adresse" slot-scope="props">
        <span v-if="props.row.produitEcranNumerique">
          {{ props.row.produitEcranNumerique.adresse | adresse }}
        </span>
      </template>
      <template slot="etat" slot-scope="props">
        <span v-if="props.row.produitEcranNumerique && props.row.produitEcranNumerique.materiel">
          {{ $t(getEtatMontage(props.row.produitEcranNumerique.materiel.etat)) }}
        </span>
      </template>
      <template slot="delete" slot-scope="{ row }">
        <div @click="$emit('removeSelection', [row])" class="is-cursor-pointer has-text-centered">
          <b-icon type="is-danger" icon="delete-forever"></b-icon>
        </div>
      </template>
      <template slot="color" slot-scope="{ row, update }">
        <div class="has-text-centered">
          <colorPicker
            v-model="row.color"
            @input="update">
          </colorPicker>
        </div>
      </template>
    </v-client-table>
    <b-modal v-model="popupColorChange">
      <div class="card pd-40px">
        <h1 class="title is-size-2 pdb-20px">{{$t('cartographie.popup.title')}}</h1>
        <div class="card-content mgl-20px">
          <colorPicker
              v-model="selectedColor"
              :isIcon="false"
              :size="40">
          </colorPicker>
        </div>
        <footer class="mgt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="popupColorChange = false">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="updateColor">
              {{ $t('cartographie.popup.appliquer') }}
            </a>
          </div>
        </b-field>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import {
  NO_PAGINATION,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { COULEUR_PUCE_DEFAULT } from '@/configuration/general/carteConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { ACTION_DELETE_SELECTION, ACTION_APPLY_COLOR } from '@/configuration/cartographie/cartographie';
import messageErreur from '@/services/general/messageErreur';
import selecteurAction from '@/components/general/selecteurAction';
import colorPicker from '@/components/general/button/colorPicker';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ecrans: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      permEmplacement: EMPLACEMENT,
      COULEUR_PUCE_DEFAULT,
      popupColorChange: false,
      selectedColor: COULEUR_PUCE_DEFAULT,
      filteredData: [],
    };
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse);
    },
  },
  components: {
    routerLinkBlank,
    selecteurAction,
    colorPicker,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ecranSelected: {
      get() {
        return this.ecrans;
      },
      set(value) {
        this.$emit('update:ecrans', value);
      },
    },
    columns() {
      const columns = ['selected', 'reference', 'adresse', 'produitEcranNumerique.adresse.codePostal', 'produitEcranNumerique.adresse.ville', 'produitEcranNumerique.adresse.departement', 'etat', 'produitEcranNumerique.format', 'produitEcranNumerique.materielType', 'produitEcranNumerique.support', 'color', 'delete'];
      return columns;
    },
    ecransSelectionnees() {
      return this.ecranSelected.filter((el) => el.selected).length > 0;
    },
    allEcranSelected() {
      this.refreshFilteredData();
      return this.filteredData.length > 0 && this.filteredData.every(f => f.selected);
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$i18n.t('listeProduitEcran.tabs.reference'),
          'produitEcranNumerique.adresse.ville': this.$i18n.t('listeProduitEcran.tabs.ville'),
          'produitEcranNumerique.adresse.codePostal': this.$i18n.t('listeProduitEcran.tabs.codePostal'),
          'produitEcranNumerique.adresse.departement': this.$i18n.t('listeProduitEcran.tabs.departement'),
          adresse: this.$i18n.t('listeProduitEcran.tabs.adresse'),
          'produitEcranNumerique.format': this.$i18n.t('listeProduitEcran.tabs.format'),
          'produitEcranNumerique.materielType': this.$i18n.t('listeProduitEcran.tabs.materiel'),
          'produitEcranNumerique.support': this.$i18n.t('listeProduitEcran.tabs.support'),
          etat: this.$i18n.t('listeProduitEcran.tabs.etat'),
          color: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: ['reference', 'adresse', 'produitEcranNumerique.adresse.codePostal', 'produitEcranNumerique.adresse.ville', 'produitEcranNumerique.adresse.departement', 'etat', 'produitEcranNumerique.format', 'produitEcranNumerique.materielType', 'produitEcranNumerique.support'],
        filterByColumn: true,
        filterAlgorithm: {
          adresse(row, query) {
            return adressFullStringGetter(row.produitEcranNumerique.adresse)
              .toLowerCase()
              .includes(query.toLowerCase());
          },
          etat(row, query) {
            return (row.produitEcranNumerique
              && row.produitEcranNumerique.materiel)
              && this.$t(this.getEtatMontage(row.produitEcranNumerique.materiel.etat))
                .toLowerCase()
                .includes(query.toLowerCase());
          },
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: TEXTS,
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
        },
        sortable: [],
        editableColumns: ['selected', 'color'],
      };
    },
    iconSelectTotal() {
      if (this.allEcranSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    actions() {
      return [
        {
          action: ACTION_DELETE_SELECTION,
          translation: 'cartographie.actions.removeSelection',
        },
        {
          action: ACTION_APPLY_COLOR,
          translation: 'cartographie.actions.applyColor',
        },
      ];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    refreshFilteredData() {
      this.filteredData = this.$refs?.ecranInSelectionTable?.allFilteredData ?? [];
    },
    updateColor() {
      this.ecrans.filter(f => f.selected).forEach(f => {
        this.$set(f, 'color', this.selectedColor);
      });
      this.popupColorChange = false;
      this.selectedColor = COULEUR_PUCE_DEFAULT;
    },
    getEtatMontage(codeEtat) {
      return ETAT_DISPOSITIF_PUBLICITAIRE.find((etat) => {
        return etat.value === codeEtat;
      })?.libelle ?? null;
    },
    selectAll() {
      const select = !this.allEcranSelected;
      this.ecrans.forEach(f => {
        if (this.filteredData.map(f => f.id).includes(f.id)) f.selected = select;
      });
      this.refreshFilteredData();
    },
    manageActions(action) {
      switch (action) {
        case ACTION_DELETE_SELECTION:
          this.$emit('removeSelection', this.ecrans.filter((el) => el.selected));
          break;
        case ACTION_APPLY_COLOR:
          this.popupColorChange = true;
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFace.errors.noActionSelect'));
          break;
      }
    },
  },
  mounted() {
    this.refreshFilteredData();
  },
};

</script>
